const enum GridPatterns {
  NA = 0,
  // This is rarely used by ROGO
  CIRCLE = 1,
  LINE = 2,
  ZONE = 3,
}

export default GridPatterns;
